import { useQuery } from '@tanstack/vue-query';
import { environmentQueries } from '@services/overig/queries/EnvironmentQueries';
import { computed, type ComputedRef } from 'vue';

type Toggle =
  | 'MaatwerkdossierToggle'
  | 'MaatwerkTermijnToggle'
  | 'MaatwerkWagenparkPerSoortVoertuigToggle'
  | 'BerekenenFilterMaatschappijToggle'
  | 'TakensysteemWeergaveToggle'
  | 'PortefeuilleDashboardToggle'
  | 'NieuweGradatieTekstenToggle'
  | 'WagenparkMutatieToggle'
  | 'WagenparkClausulesVoorwaardenOpsplitsenToggle'
  | 'ToonRichTextEditorInAanvraagdossierToggle'
  | 'RecenteActiviteitenCountersToggle'
  | 'SchadeTerugvalBerekenenToggle'
  | 'RelatiesUitgebreidZoekenViaManagementToggle'
  | 'OpenClausulesFeatureToggle'
  | 'RelatieDocumentenPaginaToggle'
  | 'PolisTonenViaManagementToggle';

/**
 * `undefined` zolang de environment nog laadt. Daarna telt een ontbrekende flag als uit: de
 * backend stuurt alleen flags mee die geconfigureerd zijn.
 */
export function useFeatureToggle(toggle: Toggle): ComputedRef<boolean | undefined> {
  const env = useQuery({
    ...environmentQueries.get(),
    select: (res) => res.data.featureFlags,
    staleTime: 60 * 1000,
    retry: 10,
  });
  return computed(() => (env.isPending.value ? undefined : (env.data.value?.[toggle] ?? false)));
}
